<template>
  <button
    class="copy-wrap"
    :class="{ showBorder: showBorder }"
    title="Click to Copy"
    @click="copyClipboard"
  >
    <Copy-Icon width="16" height="16" />
  </button>
</template>

<script>
import copyIcon from '@/assets/icons/svg/copy.svg'
import sharedFunctions from '@/assets/util/functions.js'

export default {
  name: 'Copy',
  props: ['value', 'showBorder'],
  components: {
    'Copy-Icon': copyIcon,
  },
  methods: {
    copyClipboard() {
      navigator.clipboard
        .writeText(this.value)
        .then(() => {
          sharedFunctions.showNotificationMsg('Copied', 2000)
        })
        .catch(() => {
          sharedFunctions.showNotificationMsg('Copy failed', 2000)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.copy-wrap {
  position: relative;
  background: transparent;
  width: 34px;
  border: 0;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 300ms ease;

  &:hover svg g {
    opacity: 1;
    stroke: $primary-color;
  }
  &:hover {
    z-index: 1;
    border-color: $primary-color;
  }

  &.showBorder {
    border: 1px solid rgba(102, 112, 128, 0.2);
    border-radius: 6px;
    background: #ffffff;
  }
  input {
    border: none;
    width: 100%;
    height: 1px;
    opacity: 0;
    box-shadow: none;
    outline: none;
    position: absolute;
    top: 10px;
    left: 5px;
    z-index: -1;
  }
}
</style>